<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">MENTOR FEEDBACK</h4>

            </div>
        </div>
        <div *ngIf="!tableshow" style="margin-left: 50%;">
            <div class="loader"></div>
        </div>

                <div class="container mt-4" *ngIf="customers.length > 0">
                    <div class="col-md-12">
                
                
                
                        <div class="row">
                            <div class="col-md-4" *ngFor="let item of customers">
                                <div class="card">
                                    <img class="card-img-top" style="height: 200px;"  src="https://myroots.redmindtechnologies.com/api/{{item.image}}"
                                        alt="Card image">
                                    <div class="card-body" style="height: 200px;">
                                        <h4 class="card-title" style="font-weight:bold;font-size:16px;">{{item.course_name}}</h4>
                                        <div class="card-text" style="font-size: 12px;">{{item.course_description}}</div>
                                        <span class="card-text" style="float:left">Start Date: {{item.start_date | date:'d-M-Y'}}</span>
                                        <div class="card-text" style="font-size: 14px;">Duration: {{item.hours}} Hours</div>
                                        <!-- <h6>Rating:</h6>
                                        <span class="fa fa-star checked"></span>
                                        <span class="fa fa-star checked"></span>
                                        <span class="fa fa-star checked"></span>
                                        <span class="fa fa-star"></span>
                                        <span class="fa fa-star"></span> -->
                                        <h6>Comments: {{item.comments}}</h6>
                                        <br />
                                        <button class="btn btn-primary" style="float: right;margin-right: 20px; " data-toggle="modal"
                                            data-target="#showCM" (click)="buttonviewmeeting(item,'show')">Show</button>
                
                
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        <!-- <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>Course Name</th>
                            <th>Location</th>
                            <th>Course Start </th>
                            <th>Course End </th>
                            <th>FEEDBACK</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers">
                            <td style="min-width: 20px;">
                                {{customer['course_name']}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer['location']}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer['start_date'] | date:'dd-MM-YYYY'}} {{customer['start_time']}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer['end_date'] | date:'dd-MM-YYYY'}} {{customer['end_time']}}
                            </td>

                            <td [hidden]="isButtonDisabled"><a data-toggle="modal" data-target="#showCM"
                                    class="btn btn-primary btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'show')">
                                    <i class="fas fa-flag"></i>
                                </a></td>

                            <ng-template #notShow [hidden]="isButtonDisabled">
                                <a *ngIf="customer.status=='cancel'">
                                    Cancelled

                                </a>
                            </ng-template>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div> -->


        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card ">
                        <div class="card-header newcard">
                            <h3 class="card-title">MENTOR FEEDBACK </h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Course Name<span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_course_name    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Course Location<span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_location  }}</h6>
                            </div>
                        </div>

                                </div>  

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Course Start Date<span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_startDate    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Course End Date<span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 CM_endDate  }}</h6>
                            </div>
                        </div>

                                </div> 
                                <!-- <div class="row" *ngIf="!editfield">
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Access to Venue<a style="color:red">*</a></label>
                                    <input pInputText type="text" formControlName="access_to_venue" class="form-control" placeholder="Enter Course End Date" 
                                        readonly="readonly"> -->
                                            <!-- <select class="form-control" formControlName="access_to_venue">
                                                <option value="">Select</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select> -->
                                    <!-- </div>
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Overall Co-Ordination<a
                                                style="color:red">*</a></label>
                                        <input pInputText type="text" formControlName="overall_co_ordination" class="form-control" placeholder="Enter Course End Date"
                                             readonly="readonly"> -->
                                        <!-- <select class="form-control" formControlName="overall_co_ordination">
                                            <option value="">Select</option>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                        </select> -->
                                    <!-- </div>
                                </div> -->

                                <!-- <div class="row" *ngIf="!editfield">
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Student Involvement<a
                                                style="color:red">*</a></label>
                                            <input pInputText type="text" formControlName="student_involvement" class="form-control"
                                                placeholder="Enter Course End Date" readonly="readonly"> -->
                                            <!-- <select class="form-control" formControlName="student_involvement">
                                                <option value="">Select</option>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </select> -->
                                    <!-- </div>
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Facilities in Venue<a
                                                style="color:red">*</a></label>
                                                <input pInputText type="text" formControlName="facilities_in_venue" class="form-control"
                                                    placeholder="Enter Course End Date" readonly="readonly"> -->
                                                <!-- <select class="form-control" formControlName="facilities_in_venue">
                                                    <option value="">Select</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                </select> -->
                                    <!-- </div>
                                </div>

                                <div class="row" *ngIf="!editfield">
                                    <div class="col-md-6">
                                        <label for="" class="form-label">Overall Rating About Session<a
                                                style="color:red">*</a></label>
                                            <input pInputText type="text" formControlName="overall_rating_about_session" class="form-control"
                                                placeholder="Enter Course End Date" readonly="readonly"> -->
                                                <!-- <select class="form-control" formControlName="overall_rating_about_session">
                                                    <option value="">Select</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                </select> -->
                                    <!-- </div>

                                </div> -->

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500">Comments<span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       CM_comments    }}</h6>
                                </div>
                            </div>
                                </div> 

                                <!-- <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-md-12">
                                        <label>Comments</label>
                                        <textarea class="form-control" readonly formControlName="comments"></textarea>
                                    </div>
                                </div> -->

                                <!-- <div class="py-2" *ngIf="!editfield">
                                    <div class="d-flex justify-content-center">
                                        <div style="width:200px">
                                            <button class="btn btn-success btn btn-block" data-toggle="modal" data-target="#message"
                                                data-backdrop="false">Update</button>
                                        </div>
                                    </div>
                                </div> -->


                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Course Name </label><span class="required "> *</span>
                                        <select name="course_name" class="form-control" formControlName="course_name"
                                            [(ngModel)]="CM_course_name">
                                            <option value="">Select Course Name</option>
                                            <option *ngFor="let option of courses" [value]="option.id">
                                                {{option['course_name']}}</option>

                                        </select>

                                    </div>


                                </div>
                                <div class="form-group row" *ngIf="editfield">

                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Organizer</label><span class="required "> *</span>
                                        <select name="organizer" class="form-control" formControlName="organizer"
                                            [(ngModel)]="CM_organizer">
                                            <option value="">Select Organizer</option>
                                            <option value="class">Class</option>
                                            <option *ngFor="let option of ob_data" (value)="option['firstname']">
                                                {{option['firstname']}}</option>

                                        </select>

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Start Date</label><span
                                            class="required">*</span>
                                        <input pInputText type="date" class="form-control"
                                            placeholder="Enter Course Start Date" [value]="CM_startDate">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course End Date</label><span class="required">*</span>
                                        <input pInputText type="date" class="form-control"
                                            placeholder="Enter Course End Date" [value]="CM_endDate">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Start Time</label><span
                                            class="required">*</span>
                                        <input pInputText type="time" class="form-control"
                                            placeholder="Enter Course Start Time" [value]="CM_startTime">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course End Time</label><span class="required">*</span>
                                        <input pInputText type="time" class="form-control"
                                            placeholder="Enter Course End Time" [value]="CM_endTime">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Primary Volunteer</label><span
                                            class="required">*</span>
                                        <input pInputText type="text" class="form-control"
                                            placeholder="Enter Primary Volunteer" [value]="CM_volunteer1">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Secondary Volunteer</label><span
                                            class="required">*</span>
                                        <input pInputText type="text" class="form-control"
                                            placeholder="Enter Secondary Volunteer" [value]="CM_volunteer2">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Location</label><span class="required">*</span>
                                        <input pInputText type="text" class="form-control"
                                            placeholder="Enter Course Location" [value]="CM_location">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Status</label><span class="required">*</span>
                                        <select name="status" class="form-control" formControlName="status"
                                            [(ngModel)]="CM_status">
                                            <option value="">Select any status </option>
                                            <option>Open</option>
                                            <option>Session Start</option>
                                            <option>Session End</option>
                                            <option>Inprogress</option>
                                            <option>Cancelled</option>
                                            <option>Postponed</option>
                                        </select>

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-md-12">
                                        <label>Comments</label>
                                        <textarea class="form-control" formControlName="comments"
                                            [value]="CM_comments"></textarea>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <label class="form-label">Mentor Summary</label>
                                        <!-- <div id="graphDiv"></div> -->
                                        <script src="//cdn.amcharts.com/lib/5/index.js"></script>
                                        <script src="//cdn.amcharts.com/lib/5/xy.js"></script>
                                        <script src="//cdn.amcharts.com/lib/5/themes/Animated.js"></script>
                                        <div id="chartdiv"></div>
                                    </div>
                                </div>
                                
                            <!-- <div class="py-2" *ngIf="editfield">
                                <div class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-success btn btn-block" data-toggle="modal" data-target="#message"
                                            data-backdrop="false">Update</button>
                                    </div>
                                </div>
                            </div> -->


                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>